'use client'

import React, { Suspense } from 'react'

import { Button, ButtonLink } from '@/legacy-src/components/ui/button'
import useIsAppWebView from '@/legacy-src/hooks/useIsAppWebView'
import notifyMobileApp, { NotifyAppMessages } from '@/legacy-src/utilities/notifyMobileApp'

import { getTranslate } from '../../utilities/i18n'
import Icon from '../icons/Icon'
import Loader from '../Loader'

const LockedBannerContent: React.FC = () => {
  const { t } = getTranslate()
  const isWebview = useIsAppWebView()

  const url = `${process.env.NEXT_PUBLIC_FE_URL}/client/subscription`

  return (
    <div className="py-8">
      <div className="items-center justify-between rounded-xl bg-petrol-500 px-5 py-6 tablet:flex tablet:p-8">
        <div className="items-center tablet:flex">
          <div className="mb-3 mr-8 flex h-16 w-16 items-center justify-center rounded-full bg-white tablet:mb-0">
            <Icon icon="lock" size="sm" color="primary" />
          </div>
          <div className="flex flex-col">
            <div className="text-2xl font-bold text-white">{t('component.premiumContent.locked.accessible')}</div>
            {/* <div className="text-blue-500">
            {t('component.premiumContent.locked.or')}{' '}
            <Link href="/client/account#companyBenefits" className="font-bold hover:text-primary hover:underline">
              {t('component.premiumContent.locked.companyBenefits')}
            </Link>
          </div> */}
          </div>
        </div>
        {isWebview ? (
          <Button
            size="small"
            className="mt-5 flex grow justify-center text-base tablet:mt-0 tablet:grow-0"
            onClick={() => notifyMobileApp(NotifyAppMessages.OPEN_WEBVIEW, { url: url + '?hideUi=true' })}
          >
            {t('component.button.learnMore')}
          </Button>
        ) : (
          <ButtonLink
            size="small"
            className="mt-5 flex grow justify-center text-base tablet:mt-0 tablet:grow-0"
            href={url}
          >
            {t('component.button.learnMore')}
          </ButtonLink>
        )}
      </div>
    </div>
  )
}

const LockedBanner: React.FC = () => {
  return (
    <Suspense fallback={<Loader visible loaderType="section-large" />}>
      <LockedBannerContent />
    </Suspense>
  )
}

export default LockedBanner
